import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jump",
  "use": "icon-jump-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jump\"><path fill=\"#707070\" d=\"M384 672H128a32 32 0 0 1-32-32V384a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32z m-224-64h192v-192h-192zM896 288h-128a32 32 0 0 1-32-32V128a32 32 0 0 1 32-32h128a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32z m-96-64h64v-64h-64zM896 928h-128a32 32 0 0 1-32-32v-128a32 32 0 0 1 32-32h128a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32z m-96-64h64v-64h-64zM896 608h-128a32 32 0 0 1-32-32V448a32 32 0 0 1 32-32h128a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32z m-96-64h64v-64h-64z\" /><path fill=\"#707070\" d=\"M736 864H576a32 32 0 0 1-32-32V192a32 32 0 0 1 32-32h160a32 32 0 0 1 0 64h-128v576h128a32 32 0 0 1 0 64z\" /><path fill=\"#707070\" d=\"M768 544H384a32 32 0 0 1 0-64h384a32 32 0 0 1 0 64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jump.svg
// module id = ZeDN
// module chunks = 55